/** Shared calculation. Prices passed from the server catalogue, never from a browser charge. */
export const FLEX_PLAN = 'booking_flex';
export function monthlyTotal(base:number, extra:number, professionals:number):number {
 if(!Number.isInteger(professionals)||professionals<1||professionals>500) throw new Error('Choose 1 to 500 professionals.');
 return base+extra*(professionals-1);
}
